<template>
    <div class="image_saver_body">
        <div class="image_saver_box">
            <div class="image_saver_content">
                <!-- 标签 -->
                <div class="old_tabs">
                    <!-- 返回顶部 -->
                    <el-backtop class="image_saver_backtop" target=".old_tab" :right="36" :bottom="40"><div></div></el-backtop>
                    <!-- Web 和 Google -->
                    <div class="old_tab" :data-init="webDatas.length==0?'Y':'N'">
                        <div class="imagesaver_input_button">
                            <el-input ref="webInputEle" class="imagesaver_input" type="textarea" autosize resize="none"
                                :placeholder="webInputFocus?'':webInputText"
                                v-model="webUrls" @input="limitRowsWebUrls" spellcheck="false" @focus="webInputFocus=true" @blur="webInputFocus=false"></el-input>
                            <el-button type="primary" :disabled="webUrls == ''" @click="decodeWebUrl"
                                :loading="webEncodeing">{{ webEncodeing ? $t('language.imageSaver.analyzing') : $t('language.imageSaver.download') }}</el-button>
                        </div>
                        <imageSaverPath v-show="node&&webDatas.length>0" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode"></imageSaverPath>
                        <imageSaverWebGoogleWelcome v-if="webDatas.length==0"></imageSaverWebGoogleWelcome>
                        <imageSaverView v-for="(item, index) of webDatas" :key="item.uuid" :item="item" :isPreview="false" :index="index" :itemsLength="webDatas.length" :inputHeight="webInputHeight"
                            :node="node" :updateTaskDestDrive="updateTaskDestDrive" :viewImgWigth="viewImgWigth" :lineCount="lineCount" :noImageHeight="noImageHeight"></imageSaverView>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部波浪背景 -->
        <div class="task-buttom"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import imageSaverWebGoogleWelcome from "@/components/workspace/image_saver_web_google_welcome";
import imageSaverView from "@/components/workspace/image_saver_view";
import imageSaverPath from "@/components/workspace/image_saver_path";
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";

export default {
    name: "imageSaverWeb",
    components: {
        imageSaverWebGoogleWelcome,
        imageSaverView,
        imageSaverPath,
    },
    watch: {
        // 监听目的地变化
        '$store.state.imageSaverDestNode': function(newValue) {
            this.node = newValue;
            this.updateWindowSize();
        }
    },
    data() {
        return {
            // 目的地云盘节点
            node: null,
            // WebUrl 和 Google
            webUrls: "",
            webUrlsLast: "",
            webInputHeight: 0,
            webInputFocus: false,
            webInputText: this.$t('language.imageSaver.inputTipHttp'),
            webEncodeing: false,
            webDatas: [],
            // 预览图宽
            viewImgWigth: 0,
            // 一行放几个
            lineCount: 0,
            // 没有图片的外框高
            noImageHeight: 0,
        };
    },
    mounted() {
        // 初始化窗口大小变化
        this.updateWindowSize();
        // 监听窗口大小变化
        window.addEventListener('resize', this.updateWindowSize);
        // 获取任务目的地云盘
        this.loadDestNode();
    },
    beforeDestroy() {
        // 移除窗口大小变化的监听
        window.removeEventListener('resize', this.updateWindowSize);
    },
    methods: {
        // 字符串Base64编码
        toBase64(str) {
            // 创建一个 TextEncoder 实例
            const encoder = new TextEncoder();
            // 将字符串转换为一个 Uint8Array
            const byteArray = encoder.encode(str);
            // 转Base64
            let binary = '';
            const len = byteArray.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(byteArray[i]);
            }
            return btoa(binary);
        },
        // 错误提示
        errorTips(msg) {
            this.$toast({
                text: msg,
                type: 'fail',
                idValue: "allBox"
            });
        },
        // 更新窗口大小
        updateWindowSize() {
            {
                // 计算没有图片外框高度
                this.noImageHeight = window.innerHeight - 263;
                // 没有目的地节点占位的情况下还可以再高点
                if (!this.node) this.noImageHeight += 85;
            }
            {
                // 计算预览图最终宽度
                // 362是外面所有宽，60是里面左边距，4是容错
                var boxWigth = window.innerWidth - 362 - 60 - 4;
                // 最小宽，200是需求规定，20是外边距
                var minWidth = 200 + 20;
                // 最大宽，340是需求规定，20是外边距
                var maxWidth = 340 + 20;
                // 一行放几个
                var lineCount = Math.floor((boxWigth/minWidth+boxWigth/maxWidth)/2);
                // 每个的宽度，20是外边距
                this.viewImgWigth = Math.floor(boxWigth / lineCount) - 20;
                // 赋值一行放几个
                this.lineCount = lineCount;
            }
        },
        // 加载目的地节点
        loadDestNode() {
            taskListUtils.imageSaverRequest("/loadTaskDestDrive", {}, res => {
                if (res.code == 200) {
                    commonUtils.updateImageSaverDestNode(res.data);
                } else {
                    commonUtils.updateImageSaverDestNode(null);
                }
            });
        },
        // 更新任务目的地云盘
        updateTaskDestDrive(node) {
            // 准备节点信息
            var tempNode = {};
            // 获取文件夹ID
            if (node.pnode) {
                tempNode.folder = node.id;
            } else {
                tempNode.folder = node.rootId;
            }
            // 获取云盘信息
            var path = [];
            var temp = node;
            while (temp.pnode) {
                path.push({id:temp.id,name:temp.name});
                temp = temp.pnode;
            }
            path.push({id:temp.rootId,name:temp.name});
            tempNode.path = JSON.stringify(path);
            tempNode.id = temp.id;
            tempNode.type = temp.driveType;
            // 更新节点参数准备
            var data = {};
            data.id = tempNode.id;
            data.dt = tempNode.type;
            data.n = this.toBase64(tempNode.path);
            data.pt = tempNode.folder;
            // 更新节点请求
            taskListUtils.imageSaverRequest("/updateTaskDestDrive", data, res => {
                if (res.code == 200) {
                    // 更新成功
                    commonUtils.updateImageSaverDestNode(tempNode);
                } else {
                    // 更新失败
                    commonUtils.updateImageSaverDestNode(null);
                    this.errorTips(res.message);
                }
            });
        },
        // 只能输入1行webUrls
        limitRowsWebUrls() {
            var isEnter = false;
            if (this.webUrls.split('\n').length > 1) {
                this.webUrls = this.webUrlsLast;
                isEnter = true;
            } else {
                this.webUrlsLast = this.webUrls;
            }
            setTimeout(() => {
                this.webInputHeight = this.$refs.webInputEle.$el.offsetHeight;
            }, 0);
            if (this.isValidURL(this.webUrls)) {
                // 链接自动解析
                this.decodeWebUrl();
            } else if (isEnter) {
                // 回车
                this.decodeWebUrl();
            }
        },
        // 解析一般网址 和 解析谷歌图片搜索
        decodeWebUrl() {
            // 判断是否正在解析
            if (this.webEncodeing) {
                return;
            } else {
                this.webEncodeing = true;
            }
            // 准备参数
            var path;
            var data;
            var urls = this.webUrls.split('\n');
            if (urls.length==1 && !this.isValidURL(urls[0])) {
                // 解析谷歌图片搜索
                path = "/decodeGoogleSearch";
                data = { keywords: this.webUrls.split('\n') };
            } else {
                // 解析一般网址
                path = "/decodeWebUrl";
                data = { urls: this.webUrls.split('\n') };
            }
            // 开始解析
            taskListUtils.imageSaverRequest(path, data, res => {
                this.webEncodeing = false;
                if (res.code == 200) {
                    this.webDatas = res.data;
                    for(var i=0; i<this.webDatas.length; i++) {
                        Vue.set(this.webDatas[i], 'pageIndex', 1);
                        Vue.set(this.webDatas[i], 'isLoadedNext', false);
                    }
                } else {
                    this.errorTips(res.message);
                }
            }, err => {
                this.webEncodeing = false;
                this.webDatas = [{list:[]}];
            });
        },
        // 是否是有效网址
        isValidURL(url) {
            const pattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
            return pattern.test(url);
        },
    }
};
</script>

<style>
/* 修复显示表单的BUG */
body>form {
    display: none;
}

/* 整个图片保存 */
.image_saver_body {
    top: 90px;
    height: calc(100% - 90px);
    color: black;
    position: relative;
    background-color: #F2F7FE;
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
}

/* 控制主要内容 */
.image_saver_box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 主要内容 */
.image_saver_content {
    height: 100%;
    position: relative;
}

/* 底部波浪背景 */
.image_saver_body .task-buttom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
}

/* 返回顶部 */
.image_saver_backtop>div {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-image: url("../../assets/images/imageSaver/backtopNormal.svg");
    background-repeat: no-repeat;
    background-position: center;
}
.image_saver_backtop>div:hover {
    background-image: url("../../assets/images/imageSaver/backtopHover.svg");
}
.image_saver_backtop>div:active {
    background-image: url("../../assets/images/imageSaver/backtopActive.svg");
}

/* 标签 */
.image_saver_content>.old_tabs {
    padding: 40px 0px 0px 50px;
    height: 100%;
    box-sizing: border-box;
}

.image_saver_content .old_tab {
    overflow: auto;
}

/* 标签体内容 */
.image_saver_body .old_tab {
    height: 100%;
    margin-right: 2px;
    padding-right: 48px;
}

/* 滚动条 */
.image_saver_body .old_tab::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

.image_saver_body .old_tab::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #BECAE4;
    min-height: 100px;
}

/* Web网址和按钮 */
.imagesaver_input_button {
    padding-bottom: 20px;
    display: flex;
    gap: 20px;
}

/* 输入框样式 */
.imagesaver_input>textarea {
    max-height: 93px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

/* Web网址 */
.imagesaver_input_button textarea {
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    padding: 14px 20px;
    font-size: 14px;
}

/* Web按钮 */
.imagesaver_input_button>.el-button {
    padding: 0 !important;
    min-width: 220px;
    height: 50px;
    font-size: 16px;
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:focus {
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:hover {
    border-color: #3250C9;
    background-color: #3250C9;
}

.imagesaver_input_button>.el-button--primary:active {
    border-color: #1836B0;
    background-color: #1836B0;
}

/* 禁用状态 */
.imagesaver_input_button>.el-button.is-disabled {
    border-color: #C1CBE3;
    background-color: #C1CBE3;
}

.imagesaver_input_button>.el-button.is-disabled:hover {
    border-color: #C1CBE3;
    background-color: #C1CBE3;
}

/* 正在加载文字颜色 */
.imagesaver_input_button>.el-button.is-loading {
    color: #a1addf;
}

/* 正在加载状态 */
.imagesaver_input_button>.el-button.is-loading:before {
    background-color: rgba(255, 255, 255, 0.1);
}

/* 替换加载中图标位置 */
.imagesaver_input_button .el-icon-loading {
    margin-right: 7px;
    vertical-align: middle;
    position: relative;
    bottom: 2px;
}

/* 替换加载中图标 */
.imagesaver_input_button .el-icon-loading::before {
    content: url('../../assets/images/imageSaver/loading.png');
    display: block;
    height: 20px;
    width: 20px;
}

/* 未解析前，不显示目的地路径 */
.old_tab[data-init=Y]>.image_saver_path {
    display: none;
}

/* 未解析前，输入框特殊处理 */
.old_tab[data-init=Y]>.imagesaver_input_button {
    width: 1000px;
    margin: 60px auto 0px auto;
}
.old_tab[data-init=Y]>.imagesaver_input_button>* {
    height: 64px;
}
.old_tab[data-init=Y]>.imagesaver_input_button>.el-button {
    border-radius: 8px;
}
.old_tab[data-init=Y]>.imagesaver_input_button>.imagesaver_input>textarea {
    min-height: 64px !important;
    height: 64px !important;
    padding: 20px 20px;
    font-size: 16px !important;
}
.old_tab[data-init=N]>.imagesaver_input_button>* {
    height: 50px;
}
.old_tab[data-init=N]>.imagesaver_input_button>.imagesaver_input>textarea {
    min-height: 50px !important;
    height: 50px !important;
    padding: 14px 20px;
    font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_web.vue